// The four Villa Tracker collections, and the labels a collection search looks for.
//
// A collection is a label on the villa (xdata.tags), searched with `tags $in`
// (store/redux/Property/service.js). The hubs' own sync writes those labels, and not
// always in one spelling. Counted on the villas search can show, 14 Oct 2026
// (Smiling House hub / Villa Tracker hub):
//   Events:   eventCollection 264 / 152, eventsCollection 258 / 168
//   Families: familyCollection 5,807 / 2,970, FamilyCollections 989 / 278,
//             familycollection 30 / 12, familyCollections 2 / 2
//   Pets:     petsCollection 1,090 / 841
//   Eco:      ecoCollection 1,193 / 629
// A search for one spelling left the villas with the other out, so a collection
// searches every spelling above. The partners' own free-text tags ("Pet Friendly",
// "Family Friendly", "Pet Friendly: NO", "Wedding & Events") are NOT collections and
// are not searched: one of them even says the opposite.
//
// The Eco tile used to send "Eco Friendly Collection", a label no villa carries, and
// the Search page's Eco button sends "eco friendly": both are names for ecoCollection.

export const COLLECTIONS = [
  { slug: 'events', title: 'Event Collection', tag: 'eventCollection' },
  { slug: 'families', title: 'Family Collection', tag: 'familyCollection' },
  { slug: 'pets', title: 'Pet-Friendly Collection', tag: 'petsCollection' },
  { slug: 'eco', title: 'Eco Friendly Collection', tag: 'ecoCollection' },
];

export const COLLECTION_TAG_SPELLINGS = {
  eventCollection: ['eventCollection', 'eventsCollection'],
  familyCollection: ['familyCollection', 'FamilyCollections', 'familycollection', 'familyCollections'],
  petsCollection: ['petsCollection'],
  ecoCollection: ['ecoCollection'],
};

const OTHER_NAMES = {
  'eco friendly': 'ecoCollection',
  'Eco Friendly Collection': 'ecoCollection',
};

export const collectionBySlug = (slug) => COLLECTIONS.find((c) => c.slug === slug) || null;

/** The labels to search for the chosen collections: every spelling, each once. */
export const expandCollectionTags = (chosen) => {
  const out = [];
  for (const name of Array.isArray(chosen) ? chosen : []) {
    const tag = OTHER_NAMES[name] || name;
    for (const spelling of COLLECTION_TAG_SPELLINGS[tag] || [tag]) {
      if (!out.includes(spelling)) out.push(spelling);
    }
  }
  return out;
};
